<template>
  <v-container>
    <div class="container-inner">
      <div v-if="!!getActiveWarehouse">
        <PageTitle title="Alerts" />
        <div class="table-wrapper mt-6">
          <v-row class="table-controls mb-1 items-center">
            <v-col sm="12" md="6" lg="6" cols="12">
              <div class="d-flex" v-if="items.filter((el) => el.selected).length > 0">
                <v-btn
                  color='transparent'
                  depressed
                  class='px-2'
                  @click="selectedAlertMark"
                >
                  <v-img max-height="20" max-width="20" class="mr-2" src="@/assets/icons/svg/vision.svg" />
                  <span class="text-subtitle-2 font-weight-bold">Mark as Read</span>
                </v-btn>
                <v-divider vertical class="mx-2 my-1" />
                <v-btn
                  color='transparent'
                  depressed
                  class='px-2'
                  @click="showArchiveDialog(true)"
                >
                  <v-img max-height="20" max-width="20" class="mr-2" src="@/assets/icons/svg/cardboard-box.svg" />
                  <span class="text-subtitle-2 font-weight-bold">Archive</span>
                </v-btn>
              </div>
            </v-col>
            <v-col sm="12" md="6" lg="6" cols="12">
              <v-row class="items-center">
                <v-col sm="12" md="6" lg="6" cols="12">
                  <div class="d-flex justify-end">
                    <v-card
                      id="period"
                      flat
                      class="d-flex flex-nowrap items-center mr-4"
                      width="200px !important;"
                      style="background-color: transparent; position: relative"
                    >
                      <span class="filter-title">Period:</span>
                      <div class="calendar-input calendar-block d-flex flex-nowrap items-center mr-4" @click='() => { if (!showSelectPeriod) showSelectPeriod = true }'>
                        <v-text-field
                          class="calendar-input cursor-point"
                          outlined
                          hide-details
                          dense
                          readonly
                          v-model="alertsPeriod"
                          style="background-color: white;"
                        />
                      </div>
                      <v-card
                        id="date-period"
                        class="select-period d-flex flex-nowrap pa-1"
                        style="min-width: 750px; z-index: 2"
                        v-if="showSelectPeriod"
                        v-click-outside='() => { if (showSelectPeriod) showSelectPeriod = false }'
                      >
                        <v-col cols="5">
                          <v-text-field
                            outlined
                            hide-details
                            dense
                            v-model="convertedFromDate"
                            style="background-color: white"
                            class="ml-4"
                          />
                          <v-date-picker
                            v-model="fromDate"
                            no-title
                            color="#7A71C0"
                            :max="today"
                          />
                        </v-col>
                        <v-col cols="5">
                          <v-text-field
                            outlined
                            hide-details
                            dense
                            v-model="convertedToDate"
                            style="background-color: white"
                            class="ml-4"
                          />
                          <v-date-picker
                            v-model="toDate"
                            no-title
                            color="#7A71C0"
                            :max="today"
                          />
                        </v-col>
                        <v-col cols="2">
                          <v-btn
                            class="mb-2"
                            color="#7972c0"
                            depressed
                            normal
                            dark
                            style="margin-right: 8px; width: 100px; text-transform: none"
                            @click="changeAlertsPeriod"
                          >Apply</v-btn>
                          <v-btn
                            depressed
                            normal
                            color="white"
                            style="
                            padding: 0 18px;
                            width: 100px;
                            border: 1px solid rgb(121 114 192) !important;
                            text-transform: none;
                          "
                            @click="showSelectPeriod = false"
                          ><span style="color: rgb(121 114 192)">Cancel</span></v-btn>
                        </v-col>
                      </v-card>
                    </v-card>
                  </div>
                </v-col>
                <v-col sm="12" md="6" lg="6" cols="12">
                  <div class="d-flex justify-end">
                    <v-card flat class="items-center filter-select" style="width: 250px !important; background-color: transparent; position: relative">
                      <span class="filter-title">Show:</span>
                      <v-select
                        v-model="filterAlerts"
                        outlined
                        dense
                        color="black"
                        :items="filterAlertsOptiones"
                        placeholder="All Alerts"
                        hide-details
                      />
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider />
          <v-row class="justify-space-between">
            <v-col cols="12" class="px-0">
              <v-data-table
                :headers="headers"
                :items="items"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                item-key="id"
                hide-default-footer
                @page-count="pageCount = $event"
              >
                <template v-slot:no-results>
                  <p class="text-h5 mt-16">No data available</p>
                </template>
                <template v-slot:[`item.selected`]="{ item }">
                  <v-simple-checkbox
                    v-model="item.selected"
                    color="#7972c0"
                    :ripple="false"
                  ></v-simple-checkbox>
                </template>
                <template v-slot:[`item.item.name`]="{ item }">
                <span :class="item.isRead ? '' : 'font-bold'">
                  {{ item.item.name }}
                </span>
                </template>
                <template v-slot:[`item.type`]="{ item }">
                <span :class="item.isRead ? '' : 'font-bold'"
                >Quantity is {{ item.type }} to {{ item.alertValue }}</span
                >
                </template>
                <template v-slot:[`item.createdAt`]="{ item }">
                <span :class="item.isRead ? '' : 'font-bold'">{{
                    item.createdAt
                  }}</span>
                </template>
                <template v-slot:[`item.isRead`]="{ item }">
                  <span v-if="item.archived">archived</span>
                  <span :class="item.isRead ? '' : 'font-bold'" v-else>
                  <span v-if="item.isRead">read</span>
                  <span v-else class="font-bold"> unread </span>
                </span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-row v-if="!item.archived" class="flex-nowrap">
                    <v-col cols="6" class="px-1">
                      <div
                        v-if="item.isRead"
                        style="position: relative"
                        id="markAsUnread"
                        @click="toggleMark(item)"
                      >
                        <img
                          class="mr-1 cursor-point"
                          style="height: 16px; width: 16px"
                          src="@/assets/icons/svg/hide-black.svg"
                        />
                        <span class="icon-hint"> mark as unread</span>
                        <span class="triangle"></span>
                      </div>
                      <div
                        v-else
                        style="position: relative"
                        class="markAsRead"
                        @click="toggleMark(item)"
                      >
                        <img
                          class="mr-1 cursor-point"
                          style="height: 16px; width: 16px"
                          src="@/assets/icons/svg/vision-grey.svg"
                        />
                        <span class="icon-hint"> mark as read</span>
                        <span class="triangle"></span>
                      </div>
                    </v-col>
                    <v-col cols="6" class="px-1">
                      <div style="position: relative" id="action-archive">
                        <img
                          style="height: 16px; width: 16px"
                          src="@/assets/icons/svg/cardboard-box.svg"
                          class="cursor-point"
                          @click="archiveAlert(item)"
                        />
                        <span class="icon-hint"> archive</span>
                        <span class="triangle"></span>
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row class="pagination-wrapper">
            <v-col cols="5">
              <span class="text-nowrap mr-2">Items per page</span>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    text
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    style="padding: 0; font-weight: 600"
                  >
                    {{ itemsPerPage }}
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in [5, 10, 20, 25, 50]"
                    :key="index"
                    link
                    @click="itemsPerPage = item"
                  >
                    <v-list-item-title>{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col cols="7" class="d-flex justify-end">
              <v-pagination
                v-model="page"
                :length="pageCount"
                :total-visible="6"
                color="#7972C0"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </div>
      <SelectWarehouse v-else />
    </div>
    <v-dialog v-model="showArchiveAlertsDialog" persistent max-width="768">
      <v-card class="pa-4">
        <v-card-title class="headline justify-center popup-title">
          All selected alerts will be moved to the archive?
        </v-card-title>
        <v-card-actions class="text-xs-center justify-center">
          <v-btn
            @click="showArchiveDialog(false)"
            depressed
            class="cancel-btn small-size"
          >
            Cancel
          </v-btn>
          <v-btn
            @click="archiveSelectedAlerts()"
            depressed
            class="save-btn small-size"
          >
            Archive
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- user delete modal -->
    <v-dialog v-model="alertArchiveDialog" persistent max-width="768">
      <v-card class="pa-4">
        <v-card-title class="headline justify-center popup-title">
          The alert
          <span class="font-weight-bold mx-2">
            "Quantity is {{ this.currentAlertToArchive.type }} to {{ this.currentAlertToArchive.alertValue }}"
          </span>
          for
          <span class="font-weight-bold mx-2">"{{ this.currentAlertToArchive.item.name }}"</span>
          will be moved to the archive?
        </v-card-title>
        <v-card-actions class="text-xs-center justify-center">
          <v-btn
            @click="alertArchiveDialog = false"
            depressed
            class="cancel-btn small-size"
          >
            Cancel
          </v-btn>
          <v-btn
            @click="confirmArchive"
            depressed
            class="save-btn small-size"
          >
            Archive
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { date } from 'quasar'
import PageTitle from '@/components/page/PageTitle'
import SelectWarehouse from '@/views/SelectWarehouse'
import {
  MODULE_POPUP,
  SET_ARCHIVE_ALERT_POPUP_SHOW
} from '@/store/constant/mutation-types'

const ALL_ALERTS = 'All Alerts'
const ONLY_READ_ALERTS = 'Only Read Alerts'
const ONLY_UNREAD_ALERTS = 'Only Unread Alerts'
const ARCHIVED_ALERTS = 'Archived Alerts'

export default {
  components: {
    PageTitle,
    SelectWarehouse
  },
  data() {
    return {
      today: '',
      alertsPeriod: '',
      showSelectPeriod: false,
      fromDate: '',
      toDate: '',
      currentAlertToArchive: { item: '' },
      filterAlerts: '',
      filterAlertsOptiones: [
        'All Alerts',
        'Only Read Alerts',
        'Only Unread Alerts',
        'Archived Alerts'
      ],
      headers: [
        {
          text: '',
          align: 'start',
          sortable: true,
          value: 'selected'
        },
        {
          text: 'Item Name',
          value: 'item.name',
          sortable: true,
          align: 'start'
        },
        { text: 'Alert', value: 'type', sortable: true, align: 'start' },
        { text: 'Date', value: 'createdAt', sortable: true, align: 'start' },
        {
          text: 'Status',
          value: 'isRead',
          sortable: true,
          align: 'start'
        },
        { text: '', value: 'actions', sortable: true, align: 'start' }
      ],
      itemsPerPage: 10,
      page: 1,
      pageCount: 0,
      alertArchiveDialog: false
    }
  },
  watch: {
    getActiveWarehouse(v) {
      if (v) {
        this.today = moment().format('YYYY-MM-DD')
        const payload = {
          inventoryId: v.id
        }
        this.getAlerts(payload)
      }
    }
  },
  mounted() {
    if (this.getActiveWarehouse) {
      this.today = moment().format('YYYY-MM-DD')
      const payload = {
        inventoryId: this.getActiveWarehouse.id
      }
      this.getAlerts(payload)
    }
  },
  computed: {
    ...mapGetters('alerts', ['alerts']),
    ...mapGetters('popup', ['showArchiveAlertsDialog']),
    ...mapGetters('warehouses', ['getActiveWarehouse']),
    ...mapGetters('user', {
      dateTimeFormat: 'getDateTimeFormat',
      getIsOwner: 'getIsOwner'
    }),
    convertedFromDate: {
      get: function () {
        var dateTimeFormat = ''
        if (this.fromDate === '') {
          return ''
        } else {
          dateTimeFormat =
            this.dateTimeFormat === 'undefined' ? '' : this.dateTimeFormat
          const data = moment(this.fromDate).format(dateTimeFormat)
          return this.dateTimeFormat === 'undefined' ? '' : data.slice(0, 10)
        }
      },
      set: function (newVal) {
        this.fromDate = newVal
      }
    },
    convertedToDate: {
      get: function () {
        var dateTimeFormat = ''
        if (this.toDate === '') {
          return ''
        } else {
          dateTimeFormat =
            this.dateTimeFormat === 'undefined' ? '' : this.dateTimeFormat
          const data = moment(this.toDate).format(dateTimeFormat)
          return this.dateTimeFormat === 'undefined' ? '' : data.slice(0, 10)
        }
      },
      set: function (newVal) {
        this.toDate = newVal
      }
    },
    selectedAlerts() {
      return this.items.filter((alert) => alert.selected)
    },
    dataSelectedAlerts() {
      return this.selectedAlerts.map((s) => {
        return { id: s.id, name: s.name }
      })
    },
    items() {
      switch (this.filterAlerts) {
        case ALL_ALERTS:
          return this.alerts.filter((el) => true)
        case ONLY_READ_ALERTS:
          return this.alerts.filter((el) => el.isRead && !el.archived)
        case ONLY_UNREAD_ALERTS:
          return this.alerts.filter((el) => !el.isRead && !el.archived)
        case ARCHIVED_ALERTS:
          return this.alerts.filter((el) => el.archived)
        default:
          return this.alerts
      }
    },
    dateSeparator() {
      return this.fromDate.length > 0 || this.toDate.length > 0 ? ' ~ ' : ''
    }
  },
  methods: {
    ...mapActions('alerts', ['getAlerts', 'updateNotification']),
    showArchiveDialog(value) {
      if (value && this.alerts.filter((el) => el.selected).length === 0) {
        return
      }
      this.$store.commit(`${MODULE_POPUP}/${SET_ARCHIVE_ALERT_POPUP_SHOW}`, value)
    },
    confirmArhiveAlerts() {
      const selectedAlerts = this.items.filter((el) => el.selected)
      selectedAlerts.forEach((a) => {
        const payload = {
          id: a.id,
          isRead: a.isRead,
          archived: true
        }
        this.updateNotification(payload)
      })
      this.showArchiveDialog(false)
    },
    toggleMark(item) {
      const payload = {
        id: item.id,
        isRead: !item.isRead,
        archived: item.archived
      }
      this.updateNotification(payload)
    },
    selectedAlertMark() {
      const selectedAlerts = this.items.filter((el) => el.selected)
      selectedAlerts.forEach((a) => {
        const payload = {
          id: a.id,
          isRead: true,
          archived: a.archived
        }
        this.updateNotification(payload)
      })
    },
    async filterArchivedAlerts() {
      const payload = {}
      payload.filter = {
        archived: true,
        dateStart: this.fromDate,
        dateEnd: this.toDate
      }
      await this.getAlerts(payload)
    },
    changeAlertsPeriod() {
      this.alertsPeriod =
        this.convertedFromDate + this.dateSeparator + this.convertedToDate
      const payload = {
        inventoryId: this.getActiveWarehouse.id
      }
      if (this.fromDate.length === 0 && this.toDate.length === 0) {
        this.getAlerts(payload)
        this.showSelectPeriod = false
      } else {
        payload.filter = {
          dateStart:
            this.fromDate.length === 0
              ? ''
              : date.extractDate(this.fromDate, 'YYYY-MM-DD'),
          dateEnd:
            this.toDate.length === 0
              ? ''
              : date.extractDate(this.toDate, 'YYYY-MM-DD')
        }
        switch (this.filterAlerts) {
          case ONLY_READ_ALERTS:
            payload.filter.isRead = true
            payload.filter.archived = false
            break
          case ONLY_UNREAD_ALERTS:
            payload.filter.isRead = false
            payload.filter.archived = false
            break
          case ARCHIVED_ALERTS:
            payload.filter.archived = true
            break
          default:
            break
        }
        this.getAlerts(payload)
        this.showSelectPeriod = false
      }
    },
    archiveAlert(alert) {
      this.alertArchiveDialog = true
      this.currentAlertToArchive = alert
    },
    confirmArchive() {
      const payload = {
        id: this.currentAlertToArchive.id,
        isRead: this.currentAlertToArchive.isRead,
        archived: true
      }
      this.updateNotification(payload)
      this.alertArchiveDialog = false
    },
    archiveSelectedAlerts() {
      const aSelected = this.alerts.filter((el) => el.selected)
      aSelected.forEach((a) => {
        const payload = {
          id: a.id,
          isRead: a.isRead,
          archived: true
        }
        this.updateNotification(payload)
      })
      this.showArchiveDialog(false)
    },
    submitUser() {
      this.inviteUser(this.userToSubmit)
    },
    async resend(user) {
      await this.inviteUser(user).then((res) => {
        if (res.status === 200) {
          this.resendDialog = true
          this.resendMessage = `Invitation has been resent to email ${user.email} successful.`
        } else this.resendDialog = false
      })
    },
    modalEditUser(selectedUserData, index) {
      this.tmpUserData = selectedUserData
      this.tmpUserID = index
      this.showEditUser = true
    },

    editUser(user) {
      this.$store.commit('user/set', {
        type: 'user',
        val: user
      })
      this.$router.push({ name: 'AddUser' })
    }
  }
}
</script>

<style lang="scss">
.select-period {
  position: absolute;
  top: 45px;
  right: 0;
}
#action-archive {
  .icon-hint {
    display: none;
  }
  .triangle {
    display: none;
  }
  &:hover {
    .icon-hint {
      display: block;
      background-color: #313131;
      color: white;
      position: absolute;
      top: -35px;
      left: -50%;
      width: 50px;
      padding: 4px;
      border-radius: 4px;
    }
    .triangle {
      display: block;
      content: '';
      position: absolute;
      top: -40%;
      left: 0%;
      width: 0;
      height: 0;
      border-left: solid 10px transparent;
      border-right: solid 10px transparent;
      border-top: solid 10px #313131;
    }
  }
}
.markAsRead {
  .icon-hint {
    display: none;
  }
  .triangle {
    display: none;
  }
  &:hover {
    .icon-hint {
      display: block;
      background-color: #313131;
      color: white;
      position: absolute;
      top: -35px;
      left: -100%;
      width: 85px;
      padding: 4px;
      border-radius: 4px;
    }
    .triangle {
      display: block;
      content: '';
      position: absolute;
      top: -40%;
      left: 0%;
      width: 0;
      height: 0;
      border-left: solid 10px transparent;
      border-right: solid 10px transparent;
      border-top: solid 10px #313131;
    }
  }
}
#markAsUnread {
  .icon-hint {
    display: none;
  }
  .triangle {
    display: none;
  }
  &:hover {
    .icon-hint {
      display: block;
      background-color: #313131;
      color: white;
      position: absolute;
      top: -35px;
      left: -140%;
      width: 102px;
      padding: 4px;
      border-radius: 4px;
    }
    .triangle {
      display: block;
      content: '';
      position: absolute;
      top: -40%;
      left: 0%;
      width: 0;
      height: 0;
      border-left: solid 10px transparent;
      border-right: solid 10px transparent;
      border-top: solid 10px #313131;
    }
  }
}
#period > .v-text-field--outlined fieldset {
  color: white !important;
}
#date-period {
  .v-text-field--outlined fieldset {
    color: #d1d0d5 !important;
  }
  .v-btn--rounded {
    border-radius: 4px;
  }
  .v-date-picker-table--date .v-btn {
    height: 20px;
  }
  .v-date-picker-table .v-btn {
    font-size: 14px;
    font-weight: 600;
  }
  .v-date-picker-table {
    height: 175px;
  }
}
.cursor-point {
  cursor: pointer;
}
.theme--light.v-pagination .v-pagination__item {
  background: #f5f5f5;
  box-shadow: none;
  border: 1px solid #8a8a8a;
}
.theme--light.v-pagination .v-pagination__navigation {
  background: #f5f5f5;
  box-shadow: none;
  border: 1px solid #8a8a8a;
}
.eventHandle {
  visibility: hidden;
}
.eventHandle img {
  width: 25px;
  height: 25px;
}
.actionField:hover .eventHandle {
  visibility: inherit;
}
.userTable {
  width: 100%;
}
.userTable th {
  font-size: 12px;
  color: rgb(29, 34, 43);
}
.userTable td {
  height: 60px !important;
}
.invite-num-span {
  display: inline-block;
  font-style: normal;
  font-stretch: normal;
  word-break: break-word;
  color: rgb(29, 34, 43);
  font-family: HelveticaNeue, sans-serif;
  font-weight: bold;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  padding: 0px 0px 16px;
  display: block;
}
.invite-num-description {
  display: inline-block;
  font-style: normal;
  font-stretch: normal;
  word-break: break-word;
  color: rgb(29, 34, 43);
  font-family: HelveticaNeue, sans-serif;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.2px;
  padding: 0px 0px 38px;
  display: block;
}
.username {
  display: inline-block;
  font-style: normal;
  font-stretch: normal;
  word-break: break-word;
  color: rgb(29, 34, 43);
  font-family: HelveticaNeue, sans-serif;
  font-weight: bold;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.2px;
}
.useremail {
  display: inline-block;
  font-style: normal;
  font-stretch: normal;
  word-break: break-word;
  color: rgb(113, 117, 130);
  font-family: HelveticaNeue, sans-serif;
  font-size: 10px;
  line-height: 1.43;
  letter-spacing: 0.2px;
}
.inviteUser {
  color: rgb(0, 150, 188);
}
.r-field {
  padding-top: unset;
  margin-top: unset;
}
.userInfo {
  display: inline-block;
  font-style: normal;
  font-stretch: normal;
  word-break: break-word;
  color: rgb(29, 34, 43);
  font-weight: bold;
  font-family: HelveticaNeue, sans-serif;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.2px;
}
.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  min-height: 50px;
}
.invite-user-btn {
  width: 20%;
  /* background-color: #6452a2 !important; */
  background-image: linear-gradient(to right, #8074c2, #4c486b);
  color: white !important;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 1rem !important;
  margin-right: 20px;
}
.invite-user-btn:hover {
  width: 20%;
  border: 2px solid #6452a2;
  background-color: #f5f5f5 !important;
  color: #f5f5f5 !important;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 1rem !important;
}
.label-field {
  font-size: 1rem !important;
  color: #413967;
  font-family: 'Source Sans 3', sans-serif;
}
.resend-ok-btn {
  width: 20%;
  /* background-color: #6452a2 !important; */
  background-image: linear-gradient(to right, #8074c2, #4c486b);
  color: white !important;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 1rem !important;
  margin-right: 20px;
}
.resend-ok-btn:hover {
  width: 20%;
  border: 2px solid #6452a2;
  background-color: #f5f5f5 !important;
  color: #f5f5f5 !important;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 1rem !important;
}
.font-bold {
  font-weight: bold;
}
#app #date-period .v-date-picker-table {
  height: auto;
}
</style>
